import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AxiosClient from "../../Network/AxiosClient";
import { FacematchAxiosClient } from "../../Network/FacematchAxiosClient";
import {
  selectFaceMatchEndDate,
  selectFaceMatchStartDate,
} from "../../store/selectors/face-match";
import { formatDateForApi } from "../../utilities/dateTime";
import CustomSelect from "../NewReport/Components/customSelect";
import { isPhoneNumber } from "../../utilities/phone";
import Pagination from "../Shared/Pagination/Pagination";
import SearchBar from "../Shared/SearchBar/SearchBar";
import ToggleButtonGroupBkash from "../Shared/ToggleButtonGroupBkash";
import Calendar from "../layout/Calendar";
import MultipleSelectCheckmarks from "./components/multiSelect";
import TransferList from "./components/transferList";
import "./styles/routeTransferRequest.scss";
import RegionIcon from "../NewReport/svgs/map_region.svg";
import { Redirect } from "react-router-dom";
const initialTabConfig = [
  { title: "All", key: "all" },
  { title: "Pending", key: "pending" },
  { title: "Approved", key: "approved" },
  { title: "Rejected", key: "rejected" },
];

const distributorDropDownConfig = {
  label: "Distributor",
  key: "agency",
  //disabledLabel: "Select an territory first",
  childKey: "field_force",
  paramTag: "agency",
  type: "multi-select",
  value: [],
  icon: RegionIcon,
};

const filterToTabMap = (filter) => {
  if (filter === "all") {
    return "all";
  } else if (filter === null) {
    return "pending";
  } else if (filter === true) {
    return "approved";
  } else if (filter === null) {
    return "rejected";
  }
};

const tabToFilterMap = {
  all: "all",
  pending: null,
  approved: true,
  rejected: false,
};

const initialCounts = {
  all: 20,
  pending: 0,
  approved: 0,
  rejected: 0,
};

export default function FaceMatching() {
  // const [transferList, setTransferList] = useState([]);
  const [filter, setFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [isFetching, setFetching] = useState(false);
  const [faceMatchingList, setFaceMatchingList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [reloadFlag, setReloadFlag] = useState(0);
  const [lastTimes, setLastTimes] = useState({ "page-0": undefined });
  const [agencies, setAgencies] = useState([]);
  const [selectedAgencies, setSelectedAgencies] = useState([]);
  const [selfieCounts, setSelfieCounts] = useState(initialCounts);
  const [tabConfig, setTabConfig] = useState(initialTabConfig);

  const startDate = useSelector(selectFaceMatchStartDate);
  const endDate = useSelector(selectFaceMatchEndDate);

  useEffect(() => {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (localUserToken)
      AxiosClient.get(
        `${process.env.REACT_APP_API_URL}/api/organizations/api/v1/agency`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
        .then((res) => setAgencies(res.data.data))
        .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));

    if (
      (localUserToken && searchText.length === 0) ||
      isPhoneNumber(searchText)
    ) {
      setLastTimes({ "page-0": undefined });
      setFilter("all");
      setCurrentPage(0);

      const agencies = selectedAgencies.map((agency) => agency);
      //console.log(agencies);
      getFaceMatchingListCount({ startDate, endDate, searchText, agencies });
    }
  }, [startDate, endDate, searchText, reloadFlag, selectedAgencies]);

  const getFaceMatchingList = useCallback(() => {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return;
    const agencies = selectedAgencies.map((agency) => agency);
    const status =
      filter === "all" ? undefined : filter === null ? "null" : filter;
    const lastTime = lastTimes[`page-${currentPage}`];

    setFetching(true);
    FacematchAxiosClient.get(`/selfie/list`, {
      params: {
        startDate: formatDateForApi(startDate),
        endDate: formatDateForApi(endDate),
        userId: searchText, // remove it in future CR after face match backend is fixed (change unique id to employee id from whitelisting_number)
        whitelistingNumber: searchText,
        lastTime,
        agency: agencies,
        status,
      },
    })
      .then((res) => {
        setFaceMatchingList([...res.data]);
        setFetching(false);
        if (res.data?.length > 0) {
          const lastTimeObj = { ...lastTimes };
          lastTimeObj[`page-${currentPage + 1}`] =
            res.data[res.data.length - 1].selfieTime;
          setLastTimes(lastTimeObj);
        }
      })
      .catch((err) => {
        setFetching(false);
      });
  }, [startDate, endDate, searchText, selectedAgencies, currentPage, filter]);

  useEffect(() => {
    getFaceMatchingList();
  }, [getFaceMatchingList, reloadFlag]);

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  // const totalPages = Math.ceil(data.length / pageSize);
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const getFaceMatchingListCount = ({
    startDate,
    endDate,
    searchText,
    agencies,
  }) => {
    FacematchAxiosClient.get(`/selfie/count-all-status`, {
      params: {
        startDate: formatDateForApi(startDate),
        endDate: formatDateForApi(endDate),
        userId: searchText, // remove it in future CR after face match backend is fixed (change unique id to employee id from whitelisting_number)
        whitelistingNumber: searchText,
        agency: agencies,
      },
    })
      .then((res) => {
        setSelfieCounts(res.data.count);

        const newTabConfig = [
          { title: `All (${res.data.count.all})`, key: "all" },
          { title: `Pending (${res.data.count.pending})`, key: "pending" },
          { title: `Approved (${res.data.count.approved})`, key: "approved" },
          { title: `Rejected (${res.data.count.rejected})`, key: "rejected" },
        ];
        setTabConfig(newTabConfig);
      })
      .catch((err) => console.log(err));
  };
  const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
  if (!localUserToken) return <Redirect to="/signin" />;
  return (
    <div className="main-container">
      <div className="route-transfer-container">
        <div
          className="page-header"
          style={{ justifyContent: "space-between" }}
        >
          <div className="page-heading" style={{ marginLeft: 24 }}>
            Face matching
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft: 16,
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <ToggleButtonGroupBkash
            config={tabConfig}
            alignment={filter}
            setAlignment={(f) => {
              if (f !== null) {
                setFilter(tabToFilterMap[f]);
              }
            }}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              zIndex: "5",
            }}
          >
            <Calendar
              page={"face-matching"}
              startDate={startDate}
              endDate={endDate}
            />
            {/* <MultipleSelectCheckmarks
              style={{ marginLeft: "12px" }}
              label="Select Agencies"
              options={agencies}
              selected={selectedAgencies}
              handleSelect={setSelectedAgencies}
            /> */}
            <div style={{ width: 300 }}>
              <CustomSelect
                item={{ ...distributorDropDownConfig, options: [...agencies] }}
                handleChange={(e) => setSelectedAgencies(e.target.value)}
                key={"agencies"}
                isMultiSelect={true}
              />
            </div>
            <SearchBar
              placeholder="Search by phone"
              onSearch={(text) => setSearchText(text)}
            />
          </div>
        </div>

        <div className="face-matching-pagination-container">
          <Pagination
            total={selfieCounts[filterToTabMap(filter)]}
            currentPage={currentPage}
            limit={pageSize}
            updateLimit={() => {}}
            nextPage={() => handleNextPage()}
            prePage={() => handlePrevPage()}
            disableUpdatePageLimit={true}
          />
        </div>
        <TransferList
          transferList={faceMatchingList}
          loadTransferList={() => setReloadFlag((prev) => prev + 1)}
          filter={filter}
          isFetching={isFetching}
        />
      </div>
    </div>
  );
}
